import React, { useState } from "react";
import Toptab from "../../../component/TopTab/TopTab";
import Procurement from "./procurement";
import Sales from "./Sales";
import Manufacturing from "./Munufecturing";
import BuildingPacking from "./BuildingPacking";
import Inventory from "./Inventory";
import Masters from "./Msater";


const tabs = [

    { id: "Procurement", label: "procurement", content: <Procurement /> },
    { id: "Sales", label: "Sales", content: <Sales /> },
    { id: "Manufacturing", label: "Manufacturing", content: <Manufacturing /> },
    { id: "BuildingPacking", label: "Building & Packing", content: <BuildingPacking /> },
    { id: "Inventory", label: "Inventory", content: <Inventory /> },
    { id: "Masters", label: "Masters", content: <Masters /> },
];

const ErpManagement = () => {
    const [activeTab, setActiveTab] = useState("Procurement"); // Lift the state up

    return (
        <div className="d-flex flex-column " style={{ overflow: "auto" }}>
            {/* Breadcrumb with activeTab passed as a prop */}
            {/* <Breadcrumps activeTab={activeTab} /> */}

            {/* Toptab with activeTab and setActiveTab passed as props */}

            <Toptab activeTab={activeTab} setActiveTab={setActiveTab}
                tabs={tabs}
            />

            {/* Content */}
            {/* <div className="container mt-4"></div> */}
        </div>
    );
};

export default ErpManagement;
